var APPSOURCE_MAIN_TITLE = 'AppSource';
var UNIFIED_EXPERIENCE_MAIN_TITLE = 'Marketplace';
var MS_LOGO_TEXT = 'Microsoft';
var MS_LOGO_LINK = 'https://www.microsoft.com';
var HOME_PAGE_LOCATION_TYPE = 'home';

export { APPSOURCE_MAIN_TITLE, HOME_PAGE_LOCATION_TYPE, MS_LOGO_LINK, MS_LOGO_TEXT, UNIFIED_EXPERIENCE_MAIN_TITLE };
